import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MyListApi } from "../utils/restApi";
import { useDispatch } from "react-redux";
import { addNotification } from "../slices/notificationSlice";

export const Tag = () => {

    const dispatch = useDispatch();
    const { tag: tagName } = useParams();
    const [tag, setTag] = useState(null);

    useEffect(() => {
        MyListApi.getTag(tagName)
            .then(data => {
                setTag({
                    ...data,
                    dataInfo: JSON.parse(data.dataInfo),
                });
            })
            .catch(error => {
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            });
    }, [tagName]);

    return (
        <Paper sx={{ padding: '10px' }}>
            <Typography>{`Tag ${tagName}`}</Typography>
            <Typography variant="h6">Actions</Typography>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Description</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tag && tag.actions.map((a, ix) =>
                            <TableRow key={ix}>
                                <TableCell>{a.name}</TableCell>
                                <TableCell>{a.description}</TableCell>
                            </TableRow>)}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* <pre>{JSON.stringify(tag)}</pre> */}
        </Paper>
    );
}